var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6048_6770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6048_6770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 25C13.7 25 11.6958 24.2375 9.9875 22.7125C8.27917 21.1875 7.3 19.2833 7.05 17H9.1C9.33333 18.7333 10.1042 20.1667 11.4125 21.3C12.7208 22.4333 14.25 23 16 23C17.95 23 19.6042 22.3208 20.9625 20.9625C22.3208 19.6042 23 17.95 23 16C23 14.05 22.3208 12.3958 20.9625 11.0375C19.6042 9.67917 17.95 9 16 9C14.85 9 13.775 9.26667 12.775 9.8C11.775 10.3333 10.9333 11.0667 10.25 12H13V14H7V8H9V10.35C9.85 9.28333 10.8875 8.45833 12.1125 7.875C13.3375 7.29167 14.6333 7 16 7C17.25 7 18.4208 7.2375 19.5125 7.7125C20.6042 8.1875 21.5542 8.82917 22.3625 9.6375C23.1708 10.4458 23.8125 11.3958 24.2875 12.4875C24.7625 13.5792 25 14.75 25 16C25 17.25 24.7625 18.4208 24.2875 19.5125C23.8125 20.6042 23.1708 21.5542 22.3625 22.3625C21.5542 23.1708 20.6042 23.8125 19.5125 24.2875C18.4208 24.7625 17.25 25 16 25ZM18.8 20.2L15 16.4V11H17V15.6L20.2 18.8L18.8 20.2Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.d88b8caba65681fadaf1e328968c6478.svg";
export { ForwardRef as ReactComponent };